import {createFileRoute} from '@tanstack/react-router';

import {siteKeys} from '@/features/Site/api/queryKeys';
import {getSite} from '@/features/Site/api/readSite';
import {SiteProfile} from '@/features/Site/components/SiteProfile';
import {makeDocumentTitle} from '@/utils/makeDocumentTitle';

export const Route = createFileRoute('/_b/_p/sites/$siteId')({
  component: SiteProfile,

  beforeLoad: ({params, context}) => {
    makeDocumentTitle(params.siteId);

    return {
      ...context,
      readSiteQuery: {
        queryKey: siteKeys.detail(params.siteId),
        queryFn: () => getSite(params.siteId),
      },
    };
  },

  loader({context}) {
    return Promise.all([
      context.queryClient.ensureQueryData(context.readSiteQuery),
    ]);
  },
});
